import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';

import { Row, Col, Button, Alert, Spinner, Media, Label, Input, Modal, ModalBody, ModalHeader, ModalFooter, FormGroup } from 'reactstrap';

import { connect } from 'react-redux';

import FileUploader from "react-firebase-file-uploader";
import Moment from 'react-moment';

import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import 'draft-js/dist/Draft.css';

import { stateToHTML } from 'draft-js-export-html';
import { stateFromHTML } from 'draft-js-import-html';

import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import {
  getOurStoriesBlogs,
  // getOurStoriesBlogData,
  updateOurStoriesBlogData,
  deleteOurStoriesBlogData,
} from '../../../actions/contentManagement';

import notifications from '../../../const/notifications';

import { storage } from '../../../lib/firebase';

class OurStories extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    pendingTabData: PropTypes.shape(),
  //  fetchData: PropTypes.func.isRequired,
    updateData: PropTypes.func.isRequired,
    deleteData: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: {},
    dashboardTooltips: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      success: null,
      data: '',
      editorState: EditorState.createEmpty(),
    };
  }

  componentDidMount() {
    const { fetchBlogs } = this.props;

    fetchBlogs();
  }

  openAddModal = () => {
    this.setState({ editorState: EditorState.createEmpty(), editId: null, addModalOpen: true });
  }

  openEditModal = (blogId) => {
    const { ourStoriesBlogs } = this.props;

    // fetchData(blogId).then((res) => {

      const res = ourStoriesBlogs[blogId];

    console.log('openEditModal', res);

    if (res && res.data) {
        this.setState({ data: res.data });

      const blocksFromHtml = htmlToDraft(res.data);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);

        if (contentState) {
          this.setState({ editorState: EditorState.createWithContent(contentState), editId: blogId, editModalOpen: true, image: res.image, header: res.header });
        }
      } else {
        this.setState({ editorState: EditorState.createEmpty(), editId: blogId, editModalOpen: true, image: res.image, header: res.header });
      }
    // });
  }

  closeModal = () => {
    this.setState({ addModalOpen: null, editModalOpen: null, error: null, deleteModalOpen: false, deleteBlogId: null, editId: null });
  }

  onChange = (editorState) => {
    this.setState({ editorState })
  };

  handleChangeText = (e) => {
    e.preventDefault();

    if (e.target) {
      const { value } = e.target;
      this.setState((prevState) => ({
        data: value,
        error: null,
        success: null,
      }))
    }
  };

  handleChange = (e) => {
    e.preventDefault();

    if (e.target) {
      console.log('e.target', e.target);
      const { value, name } = e.target;
      this.setState((prevState) => ({
        [name]: value,
        error: null,
        success: null,
      }))
    }
  };

  updateData = () => {
    const { updateData, user, fetchBlogs } = this.props;
    const { editorState, editId, header, image } = this.state;

    console.log('editId', editId);

    if (!editorState) {
      this.setState({ error: 'missingText' });
      return null;
    }

    if (!header) {
      this.setState({ error: 'missingHeader' });
      return null;
    }

    if (!image) {
      this.setState({ error: 'missingImage' });
      return null; 
    }

      let html = stateToHTML(editorState.getCurrentContent());

      console.log('html', { html });

      const rawContentState = convertToRaw(editorState.getCurrentContent());

      const markup = draftToHtml(
        rawContentState
      );

      this.setState({ saveSpinner: true });

      let adminName;

      if (user.name || (user.firstName && user.lastName)) {
        adminName = user.name ? user.name : `${user.firstName} ${user.lastName}`;
      }

      updateData(markup, header, image, editId, adminName).then((res) => {
        if (res === 'success') {
          this.setState({ saveSpinner: null, success: true, error: null, addModalOpen: null, editModalOpen: null });

          fetchBlogs();
        } else if (res === 'error') {
          this.setState({ saveSpinner: null, success: null, error: true });
        }
      });
  }

  handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });

  handleProgress = progress => this.setState({ progress });

  handleUploadError = error => {
    this.setState({ isUploading: false, error });
    console.error(error);
  };

  handleUploadSuccess = filename => {
    console.log('filename', filename);
    this.setState({ avatar: filename, progress: 100, isUploading: false });
    storage
      .ref("blogsImages")
      .child(filename)
      .getDownloadURL()
      .then(url => {
        console.log('blogsImages url', url);
        this.setState({ image: url, filename });
      });
  };

  openDeleteModal = (id) => {
    this.setState({ deleteModalOpen: true,  deleteBlogId: id, editModalOpen: null, addModalOpen: null });
  }

  deleteBlog = () => {
    const { deleteData, fetchBlogs, user } = this.props;
    const { deleteBlogId } = this.state;

    let adminName;

    if (user.name || (user.firstName && user.lastName)) {
      adminName = user.name ? user.name : `${user.firstName} ${user.lastName}`;
    }

    deleteData(deleteBlogId, adminName).then(() => {
      fetchBlogs();

      this.closeModal();
    });
  }

  render() {
    const { showNoPermission, ourStoriesBlogs } = this.props;
    const {
      error,
      success,
      editorState,
      saveSpinner,

      addModalOpen, 
      editModalOpen,
      deleteModalOpen,
      editId,
      header,
      image,
    } = this.state;

    console.log('editorState', { editorState });

    return (
      <div>
        {(!!success) && <Alert color="success">{notifications.admin.contentManagement.updateSuccessful}</Alert>}
        {(!!error) && <Alert color="danger">{notifications.admin.contentManagement.updateFailed}</Alert>}

        <Row>
          <Col xs="12">
            <Button onClick={() => this.openAddModal()}>Add</Button>
          </Col>
        </Row>

        <Row>
          <Col xs="3">
            Header
          </Col>

          <Col xs="3">
            Image
          </Col>

          <Col xs="2">
            Date
          </Col>

          <Col xs="2">
            Edit
          </Col>

          <Col xs="2">
            Delete
          </Col>
        </Row>

        {ourStoriesBlogs && Object.keys(ourStoriesBlogs).map((key) => (
          <>
            <Row>
              <Col xs="3">
                {ourStoriesBlogs[key].header}
              </Col>

              <Col xs="3">
                <Media src={ourStoriesBlogs[key].image} alt=""/>
              </Col>

              <Col xs="2">
                {ourStoriesBlogs[key].date ? (
                  <Moment format="DD-MM-YYYY HH:mm" locale="=uk">
                    {ourStoriesBlogs[key].date.seconds ? (
                      ourStoriesBlogs[key].date.seconds * 1000
                    ) : (
                        ourStoriesBlogs[key].date
                    )}
                  </Moment>
                ) : (null)}
              </Col>

              <Col xs="2">
                <Button onClick={() => this.openEditModal(key)}>Edit</Button>
              </Col>

              <Col xs="2">
                <Button onClick={() => this.openDeleteModal(key)}>Delete</Button>
              </Col>
            </Row>
          </>
        ))}

        <Modal size="xl" isOpen={addModalOpen} toggle={this.closeModal}>
          <ModalHeader toggle={this.closeModal}>
            Add Story
          </ModalHeader>
          <ModalBody>
            {(!!error) && <Alert color="danger">{error}</Alert>}
            <FormGroup>
              <Label for="header">
                Header
              </Label>
              <Input type="text" name="header" className="form-control" value={header} onChange={(e) => this.handleChange(e)} />
            </FormGroup>
            <FormGroup>
              <Label for="image">
                Image
              </Label>
              {this.state.image ? (
                <img
                  alt="uploadedImage"
                  src={this.state.image}
                  className="perks-modal-image"
                  style={{ maxWidth: 150, width: '60%', marginLeft: '20%', marginRight: '20%', objectFit: 'contain', aspectRatio: 1 }}
                />
              ) : null}
              {this.state.isUploading && <p>Progress: {this.state.progress}</p>}
              <FileUploader
                accept="image/*"
                name="image"
                randomizeFilename
                storageRef={storage.ref("blogsImages")}
                onUploadStart={this.handleUploadStart}
                onUploadError={this.handleUploadError}
                onUploadSuccess={this.handleUploadSuccess}
                onProgress={this.handleProgress}
              />
            </FormGroup>
            <FormGroup>
              <Label for="text">
                Text
              </Label>
              <Editor
                name="text"
                className="content-management-text-area"
                editorState={editorState}
                toolbarClassName="our-stories-toolbar"
                wrapperClassName="our-stories-wrapper"
                editorClassName="our-stories-editor-body"
                onEditorStateChange={this.onChange}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button disabled={showNoPermission} onClick={this.updateData}>
              Save
              {(saveSpinner) ? (
                <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
              ) : (null)}
            </Button>
            <Button color="secondary" onClick={this.closeModal}>Close</Button>
          </ModalFooter>
        </Modal>



        <Modal size="xl" isOpen={editModalOpen} toggle={this.closeModal}>
          <ModalHeader toggle={this.closeModal}>
            Edit Story
          </ModalHeader>
          <ModalBody>
            {(!!error) && <Alert color="danger">{error}</Alert>}
            <FormGroup>
              <Label for="header">
                Header
              </Label>
              <Input type="text" name="header" className="form-control" value={header} onChange={(e) => this.handleChange(e)} />
            </FormGroup>
            <FormGroup>
              <Label for="newImage">
                Image
              </Label>
              {this.state.newImage ? (
                <img
                  alt="uploadedImage"
                  src={this.state.newImage}
                  className="perks-modal-image"
                  style={{ maxWidth: 150, width: '60%', marginLeft: '20%', marginRight: '20%', objectFit: 'contain', aspectRatio: 1 }}
                />
              ) : null}
              {this.state.isUploading && <p>Progress: {this.state.progress}</p>}
              <FileUploader
                accept="image/*"
                name="image"
                randomizeFilename
                storageRef={storage.ref("blogsImages")}
                onUploadStart={this.handleUploadStart}
                onUploadError={this.handleUploadError}
                onUploadSuccess={this.handleUploadSuccess}
                onProgress={this.handleProgress}
              />
            </FormGroup>
            <FormGroup>
              <Label for="text">
                Text
              </Label>
              <Editor
                name="text"
                className="content-management-text-area"
                editorState={editorState}
                toolbarClassName="our-stories-toolbar"
                wrapperClassName="our-stories-wrapper"
                editorClassName="our-stories-editor-body"
                onEditorStateChange={this.onChange}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button disabled={showNoPermission} onClick={this.updateData}>
              Save
              {(saveSpinner) ? (
                <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
              ) : (null)}
            </Button>
            <Button color="secondary" onClick={this.closeModal}>Close</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={deleteModalOpen} toggle={this.closeModal}>
          <ModalHeader toggle={this.closeModal}>
            Delete Story
          </ModalHeader>
          <ModalBody>

          </ModalBody>
          <ModalFooter>
            <Button disabled={showNoPermission} onClick={this.deleteBlog}>
              Confirm
              {(saveSpinner) ? (
                <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
              ) : (null)}
            </Button>
            <Button color="secondary" onClick={this.closeModal}>Close</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.userData || {},
  ourStoriesBlogs: state.contentManagement.ourStoriesBlogs || {},
});

const mapDispatchToProps = {
  fetchBlogs: getOurStoriesBlogs,
  // fetchData: getOurStoriesBlogData,
  updateData: updateOurStoriesBlogData,
  deleteData: deleteOurStoriesBlogData,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OurStories));
